import { ApiError } from "@/lib/api-client";

// Maps a thrown begin-calibration verify error to a screen state (Story 10.10,
// AC 4). Branches ONLY on the structured `error.code` / `error.status` (never
// the raw message/details — legacy-signup-error.ts pattern). The two coded
// outcomes mirror the backend's deliberately generic pair:
//   AUTH-012 (429) → `throttled`   — per-email / per-IP window tripped;
//   AUTH-013 (503) → `service-error` — LearnWorlds unreachable OR unconfigured.
// A 422 (malformed email that slipped past the client check) surfaces inline on
// the field; EVERYTHING else — network failure, unknown code — collapses into
// `service-error`, which reveals nothing about completion or account state.
//
// [Source: src/application/authentication/begin_calibration_verify/exceptions.py]

export interface BeginCalibrationError {
  /** Terminal screen state, or null when handled inline on the email field. */
  state: "throttled" | "service-error" | null;
  /** Inline message for the email field (422), or null. */
  emailMessage: string | null;
}

export function toBeginCalibrationError(error: unknown): BeginCalibrationError {
  if (error instanceof ApiError) {
    if (error.code === "AUTH-012" || error.status === 429) {
      return { state: "throttled", emailMessage: null };
    }
    if (error.status === 422) {
      return { state: null, emailMessage: "Enter a valid email address." };
    }
  }
  // AUTH-013 / network failure / unknown → the generic service-error state.
  return { state: "service-error", emailMessage: null };
}
